import './HomeScreen.css';
import React from 'react'
import Banner from './Components/Banner';
import LatestVideos from './Components/LatestVideos';

function HomeScreen() {
    return (
        <div className="home">
            <div className="home_container">
                <Banner />
                <LatestVideos />
            </div>
        </div>
    )
}

export default HomeScreen
